const mediaBanner = () => {
    const mediaBanners = document.querySelectorAll('[data-media-banner] video');
    const handleIntersection = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const video = entry.target;
                video.play();
            }
            else {
                const video = entry.target;
                video.pause();
            }
        });
    };
    const observerOptions = {
        threshold: 0.5, // video pause/play triggered when 50% in viewport
    };
    const observer = new IntersectionObserver(handleIntersection, observerOptions);
    mediaBanners.forEach((banner) => {
        observer.observe(banner);
    });
};
export { mediaBanner };
